/* ==========================================================================
   BLINDAX — comportamiento de las secciones a medida
   Todo es opcional y degrada sin errores si el navegador no lo soporta
   o si el visitante tiene activado "reducir movimiento".
   ========================================================================== */

(function () {
  'use strict';

  var reduced =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var canAnimate = 'IntersectionObserver' in window && !reduced;

  /* El CSS deja el contenido VISIBLE por defecto. Solo lo ocultamos para
     animarlo si de verdad podemos volver a mostrarlo. Así, si algo falla,
     la tienda se ve igual en lugar de quedarse en blanco. */
  if (canAnimate) document.documentElement.classList.add('bx-js');

  // Red de seguridad: pase lo que pase, a los 3 s todo lo pendiente es visible.
  function safetyNet(root) {
    if (!canAnimate) return;
    window.setTimeout(function () {
      var pending = (root || document).querySelectorAll('.bx-reveal:not(.bx-in)');
      for (var i = 0; i < pending.length; i++) pending[i].classList.add('bx-in');
    }, 3000);
  }

  /* ---------------------------------------------------------------
     1. Aparición al hacer scroll
     --------------------------------------------------------------- */
  function initReveal(root) {
    var items = (root || document).querySelectorAll('.bx-reveal:not([data-bx-observed])');
    if (!items.length) return;

    if (!canAnimate) {
      items.forEach(function (el) {
        el.setAttribute('data-bx-observed', '');
        el.classList.add('bx-in');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('bx-in');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -12% 0px', threshold: 0.05 }
    );

    items.forEach(function (el) {
      el.setAttribute('data-bx-observed', '');
      observer.observe(el);
    });
  }

  /* ---------------------------------------------------------------
     2. Contadores animados  ->  <span class="bx-stat__value" data-bx-count="98" data-bx-suffix="%">
     --------------------------------------------------------------- */
  function initCounters(root) {
    var nodes = (root || document).querySelectorAll('[data-bx-count]:not([data-bx-counted])');
    if (!nodes.length) return;

    function run(el) {
      el.setAttribute('data-bx-counted', '');
      var target = parseFloat(el.getAttribute('data-bx-count'));
      if (isNaN(target)) return;
      var prefix = el.getAttribute('data-bx-prefix') || '';
      var suffix = el.getAttribute('data-bx-suffix') || '';
      var decimals = (el.getAttribute('data-bx-count').split('.')[1] || '').length;

      if (reduced) {
        el.textContent = prefix + target.toFixed(decimals).replace('.', ',') + suffix;
        return;
      }

      var duration = 1100;
      var start = null;

      function frame(ts) {
        if (start === null) start = ts;
        var p = Math.min((ts - start) / duration, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        var value = (target * eased).toFixed(decimals).replace('.', ',');
        el.textContent = prefix + value + suffix;
        if (p < 1) requestAnimationFrame(frame);
      }

      requestAnimationFrame(frame);
    }

    if (!('IntersectionObserver' in window)) {
      nodes.forEach(run);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          run(entry.target);
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.4 }
    );

    nodes.forEach(function (el) {
      observer.observe(el);
    });
  }

  /* ---------------------------------------------------------------
     3. Selector de colores (sección "BLINDAX · Colores")
     --------------------------------------------------------------- */
  function initColorway(root) {
    var blocks = (root || document).querySelectorAll('[data-bx-colorway]:not([data-bx-ready])');

    blocks.forEach(function (block) {
      block.setAttribute('data-bx-ready', '');
      var swatches = block.querySelectorAll('.bx-swatch');
      var slides = block.querySelectorAll('.bx-colorway__slide');
      if (!swatches.length || !slides.length) return;

      function select(index) {
        swatches.forEach(function (s, i) {
          s.setAttribute('aria-pressed', i === index ? 'true' : 'false');
        });
        slides.forEach(function (s, i) {
          s.classList.toggle('is-active', i === index);
        });
      }

      swatches.forEach(function (swatch, index) {
        swatch.addEventListener('click', function () {
          select(index);
        });
        swatch.addEventListener('keydown', function (event) {
          if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
          event.preventDefault();
          var next =
            event.key === 'ArrowRight'
              ? (index + 1) % swatches.length
              : (index - 1 + swatches.length) % swatches.length;
          select(next);
          swatches[next].focus();
        });
      });

      select(0);
    });
  }

  /* ---------------------------------------------------------------
     4. Parallax muy sutil del producto en el hero
     --------------------------------------------------------------- */
  function initParallax(root) {
    if (reduced) return;
    var targets = (root || document).querySelectorAll('[data-bx-parallax]:not([data-bx-plx])');
    if (!targets.length) return;

    targets.forEach(function (el) {
      el.setAttribute('data-bx-plx', '');
    });

    var all = document.querySelectorAll('[data-bx-plx]');
    var ticking = false;

    function update() {
      ticking = false;
      var vh = window.innerHeight || 1;
      all.forEach(function (el) {
        var rect = el.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > vh) return;
        var strength = parseFloat(el.getAttribute('data-bx-parallax')) || 12;
        var progress = (rect.top + rect.height / 2 - vh / 2) / vh;
        el.style.transform = 'translate3d(0,' + (progress * strength).toFixed(2) + 'px,0)';
      });
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  }

/* ---------------------------------------------------------------
     5. Cuenta atrás hasta una fecha real
     --------------------------------------------------------------- */
  function initCountdown(root) {
    var nodes = (root || document).querySelectorAll('[data-bx-countdown]:not([data-bx-cd-on])');
    for (var i = 0; i < nodes.length; i++) {
      (function (el) {
        el.setAttribute('data-bx-cd-on', '');
        var end = new Date(el.getAttribute('data-end')).getTime();
        if (isNaN(end)) return;

        var d = el.querySelector('[data-bx-d]');
        var h = el.querySelector('[data-bx-h]');
        var m = el.querySelector('[data-bx-m]');
        var s = el.querySelector('[data-bx-s]');
        var pad = function (n) { return n < 10 ? '0' + n : String(n); };

        function tick() {
          var left = end - Date.now();
          if (left <= 0) {
            el.classList.add('is-ended');
            var label = el.querySelector('.bx-countdown__label');
            var txt = el.getAttribute('data-ended-text');
            if (label && txt) label.textContent = txt;
            clearInterval(timer);
            return;
          }
          var sec = Math.floor(left / 1000);
          if (d) d.textContent = pad(Math.floor(sec / 86400));
          if (h) h.textContent = pad(Math.floor((sec % 86400) / 3600));
          if (m) m.textContent = pad(Math.floor((sec % 3600) / 60));
          if (s) s.textContent = pad(sec % 60);
        }

        tick();
        var timer = setInterval(tick, 1000);
      })(nodes[i]);
    }
  }

  /* ---------------------------------------------------------------
     Arranque + soporte del editor de temas
     --------------------------------------------------------------- */
  function boot(root) {
    initReveal(root);
    initCounters(root);
    initColorway(root);
    initParallax(root);
    safetyNet(root);
    initCountdown(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot(document);
    });
  } else {
    boot(document);
  }

  // Al editar una sección en Shopify, el bloque se vuelve a renderizar
  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
  document.addEventListener('shopify:section:select', function (event) {
    boot(event.target);
  });
})();
